/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import classes from "./signin.module.scss";
import { useAuth0 } from "@auth0/auth0-react";
import logo from '../../asset/Travelsment.png';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CloseIcon from '@mui/icons-material/Close';
import ProfileInfo from "./siginFeatures/profileInfo";
import { useLazyQuery } from "@apollo/client";
import { GET_PERSONAL_DATA } from "../../graphQL/queries";
import DataList from "./siginFeatures/datalist";
import { useSelector } from "react-redux";
import Loader from "./Common/Loader";
import { PastSvg, ProposalSvg, TransactionSvg, TravelsmentIconSvg, UpComingSvg, WishListSvg } from "../../constants/resources";
import { RootState } from "../../App";
import { Itinerary, ItineraryActivity, PersonData, UserProfile } from "../../atom/Types";
import { keyExistInObject } from "../../atom/utilities/function";
import Transaction from "./siginFeatures/transaction";
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import Referrals from "./siginFeatures/Referrals";
import Quotes from "../Quotes";
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import { isDev } from "../../constants/constantValue";

const SignUp = () => {
    const { Profile } = useSelector((state: RootState) => state.Question);
    const { user } = useAuth0();
    const [options, setOptions] = useState(false)
    const [type, setType] = useState('No')
    const [profile, setProfile] = useState('Main');
    const [upComing, setUpComing] = useState<Itinerary[]>([])
    const [proposal, setProposal] = useState<Itinerary[]>([])
    const [past, setPast] = useState<Itinerary[]>([])
    const [paidItems, setPaidItems] = useState<ItineraryActivity[]>([])
    const tripPlannerUrl = `https://${window.location.hostname}:${window.location.port}`;

    const handleOptions = (value: string) => {
        setOptions(false)
        setType(value)
    }

    const [getData, { data: PersonalData, loading }] = useLazyQuery<PersonData>(GET_PERSONAL_DATA);

    useEffect(() => {
        if (user?.email) {
            getData({
                variables: { email: user?.email },
                fetchPolicy: 'cache-first',
                nextFetchPolicy: 'cache-first',
                notifyOnNetworkStatusChange: true
            });
        }
    }, [user?.email]);

    console.log(PersonalData, 'PersonalData');


    useEffect(() => {
        // ;
        let array: Itinerary[] = [];
        let upComing: Itinerary[];
        let proposal: Itinerary[];
        let past: Itinerary[];
        let paid: ItineraryActivity[] = []

        if (PersonalData?.queryTravelAnswer && PersonalData?.queryTravelAnswer.length > 0) {
            PersonalData?.queryTravelAnswer.forEach((node) => {
                if (node.itineraries) {
                    node.itineraries.forEach((items) => {
                        array.push(items)
                    })
                }
            })
            upComing = array.filter((n) => {
                var d = new Date();
                d.setDate(d.getDate() - 1);
                return n.type === 'Actual' && new Date(n.endDate) >= d
            });
            proposal = array.filter((n) => {
                return n.type === "Proposal"
            });
            past = array.filter((n) => {
                return n.type === 'Actual' && new Date(n.endDate) <= new Date()
            });

            array.filter(n => n.type === 'Actual')
                .flatMap(n => n.days)
                .filter(day => day.dayActivities.length > 0)
                .flatMap(day => day.dayActivities)
                .filter(act => act.paymentRecords.length > 0)
                .forEach(act => paid.push(act));

            setPaidItems([...paid])
            setUpComing([...upComing])
            setPast([...past])
            setProposal([...proposal])
        }
    }, [PersonalData])

    console.log(paidItems, 'paidItems');

    const handleData = (value: string) => {
        setProfile(value)
    }

    return !loading ? <div className={classes.mainPage}>
        <div className={classes.Header}>
            <div className={classes.HeaderLogo}>
                <img className={classes.logo} src={logo} alt="logo"></img>
                <div className={classes.logoIcon}>
                    <TravelsmentIconSvg />
                </div>
            </div>
            <div onClick={() => setProfile("Profile")} className={classes.HeaderRight}>
                <div className={classes.HeaderName}>
                    {Profile !== null && Profile !== undefined && Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') as string : user?.nickname}
                </div>
                <div className={classes.avatarMain}>
                    <img className={classes.avatar} src={user?.picture} alt="avatar"></img>
                </div>

            </div>

        </div >

        {profile === 'Quotes' ? <Quotes setProfile={setProfile} profile={profile} /> :
            profile === 'Referrals' ? <Referrals setProfile={setProfile} profile={profile} /> :
                profile === 'Profile' ?
                    <ProfileInfo setProfile={setProfile} /> :
                    profile === 'Upcoming' ?
                        <DataList filterData={upComing} setProfile={setProfile} profile={profile} /> :
                        profile === 'Proposal' ?
                            <DataList filterData={proposal} setProfile={setProfile} profile={profile} /> :
                            profile === 'WishList' ?
                                <DataList filterData={keyExistInObject(Profile as UserProfile, 'wishList') ? keyExistInObject(Profile as UserProfile, 'wishList') : []} setProfile={setProfile} profile={profile} /> :
                                profile === 'Past' ?
                                    <DataList filterData={past} setProfile={setProfile} profile={profile} /> :
                                    profile === 'Transactions' ?
                                        <Transaction filterData={paidItems} setProfile={setProfile} profile={profile} /> :
                                        <div className={classes.Body}>
                                            <div className={classes.centerBox} style={{ justifyContent: 'left' }}>
                                                <div className={classes.WP}>
                                                    <div onClick={() => handleData("Upcoming")} className={classes.tiles}>
                                                        <div>
                                                            <UpComingSvg upComing={upComing} />
                                                        </div>
                                                        <div className={classes.Name}>Upcoming</div>

                                                    </div >
                                                    <div onClick={() => handleData("Proposal")} className={classes.tiles}>
                                                        <div>
                                                            <ProposalSvg proposal={proposal} />
                                                        </div>
                                                        <div className={classes.Name}> Proposals</div>
                                                    </div>
                                                </div>
                                                <div className={classes.WP}>
                                                    <div onClick={() => handleData("WishList")} className={classes.tiles}>
                                                        <div>
                                                            <WishListSvg UserProfile={keyExistInObject(Profile as UserProfile, '')} />
                                                        </div>
                                                        <div className={classes.Name}>
                                                            Wish list
                                                        </div>
                                                    </div>
                                                    <div onClick={() => handleData("Past")} className={classes.tiles}>
                                                        <div>
                                                            <PastSvg past={past} />
                                                        </div>
                                                        <div className={classes.Name}> Past Itineraies</div>

                                                    </div>
                                                </div>
                                                <div className={classes.WP}>
                                                    <div onClick={() => handleData("Transactions")} className={classes.tiles}>
                                                        <div>
                                                            <TransactionSvg paidItems={paidItems} />
                                                        </div>
                                                        <div className={classes.Name}>
                                                            Transaction
                                                        </div>
                                                    </div>
                                                    <div onClick={() => handleData("Referrals")} className={classes.tiles}>
                                                        <div>
                                                            <PeopleAltTwoToneIcon style={{ transform: 'scale(1.5)', margin: "20px" }} fontSize="large" color="info" />
                                                        </div>
                                                        <div className={classes.Name}>
                                                            Referrals
                                                        </div>
                                                    </div>
                                                </div>
                                                {isDev() && <div className={classes.WP} style={{ justifyContent: 'center!important' }}>
                                                    <div onClick={() => handleData("Quotes")} className={classes.tiles}>
                                                        <div>
                                                            <RequestQuoteOutlinedIcon style={{ transform: 'scale(1.5)', margin: "20px" }} fontSize="large" color="info" />
                                                        </div>
                                                        <div className={classes.Name}>
                                                            Quotes
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div className={classes.PMT}>
                                                    <button onClick={() => setOptions(!options)} className={classes.bbutton}>PLAN MY TRIP
                                                        <span className={classes.icon}>
                                                            {options ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                                        </span>

                                                    </button>
                                                    {
                                                        options ? <div className={classes.options}>
                                                            <div className={classes.BW} onClick={() => handleOptions("BeachVacation")}>
                                                                Beach Vacation
                                                            </div>
                                                            <div className={classes.BW} onClick={() => handleOptions("WorldExploration")}>
                                                                World Exploration
                                                            </div>
                                                            <div className={classes.BW} onClick={() => handleOptions("Cruise")}>
                                                                Cruise
                                                            </div>
                                                        </div> : null
                                                    }
                                                </div>
                                                {type === 'No' ? null : <div className={classes.iFrameBg}>
                                                    <div className={classes.iFrameMain}>
                                                        <div className={classes.iFrame}>
                                                            <div className={classes.iFrameClose} onClick={() => setType('No')}>
                                                                <CloseIcon />
                                                            </div>
                                                            <iframe title="Travelsment" src={`${tripPlannerUrl}/?q=${type}`}></iframe>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {/* <button onClick={() => logout({ returnTo: window.location.origin + '/viewer/' })}>Logout</button> */}
                                            </div>
                                        </div>
        }
    </div> : <Loader content="Loading..." />
}

export default SignUp 